import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Button } from 'reactstrap';
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppUserAnalytics } from '../../../../slices/veloxity/adminAnalytics/getTotalAppUserAnalyticSlice';

const TotalAppUserAnalytics = ({ licenseKey }) => {
    const dispatch = useDispatch();
    const appUserData = useSelector((state) =>
        Array.isArray(state.totalAppUserAnalytics?.data) ? state.totalAppUserAnalytics.data : []
    );
    const [selectedTime, setSelectedTime] = useState("3M");

    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--vz-primary').trim();
    const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--vz-secondary').trim();

    useEffect(() => {
        if (licenseKey && selectedTime) {
            const { startDate, endDate } = getTimeRange(selectedTime);
            dispatch(fetchAppUserAnalytics({ licenseKey, startDate, endDate }));
        }
    }, [dispatch, licenseKey, selectedTime]);

    const handleTimeChange = (timeRange) => {
        setSelectedTime(timeRange);
    };

    const getTimeRange = (timeRange) => {
        const today = new Date();
        const endDate = today.toISOString().split('T')[0];
        let startDate;

        switch (timeRange) {
            case "1W":
                startDate = new Date(today.setDate(today.getDate() - 7)).toISOString().split('T')[0];
                break;
            case "1M":
                startDate = new Date(today.setMonth(today.getMonth() - 1)).toISOString().split('T')[0];
                break;
            case "3M":
                startDate = new Date(today.setMonth(today.getMonth() - 3)).toISOString().split('T')[0];
                break;
            default:
                startDate = "2000-01-01"; // Varsayılan olarak tüm tarih
        }

        return { startDate, endDate };
    };

    const series = [{
        name: "Device Count",
        type: 'area',
        data: appUserData.map(item => item.deviceCount),
    }];

    const options = {
        chart: {
            height: 370,
            type: "area",
            toolbar: { show: false },
        },
        colors: [primaryColor],
        stroke: {
            curve: "smooth",
            width: 2,
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 90, 100],
            },
        },
        dataLabels: {
            enabled: false, // Rakamlar yazılmasın
        },
        markers: {
            size: 4,
            strokeWidth: 2,
            hover: { size: 6 },
        },
        xaxis: {
            categories: appUserData.map(item => item.date),
            title: { text: 'Date' },
            labels: {
                rotate: -45,
                format: 'yyyy-MM-dd',
            },
        },
        yaxis: {
            title: { text: 'Device Count' },
            labels: {
                formatter: (val) => val.toLocaleString('en-US'),
            },
        },
        grid: {
            show: true,
            xaxis: { lines: { show: true } },
            yaxis: { lines: { show: false } },
            padding: { top: 0, right: -2, bottom: 15, left: 10 },
        },
        legend: {
            show: true,
            horizontalAlign: "center",
            offsetX: 0,
            offsetY: -5,
            markers: { width: 9, height: 9, radius: 6 },
            itemMargin: { horizontal: 10, vertical: 0 },
        },
        tooltip: {
            shared: true,
            y: {
                formatter: (val) => val.toLocaleString('en-US'),
            },
        },
    };
    

    return (
        <Card>
            <CardHeader className="align-items-center d-flex" style={{ padding: '25px 15px' }}>
                <h4 className="card-title mb-0 flex-grow-1">Total App User Analytics</h4>
                <div>
                    <Button
                        color={selectedTime === "1W" ? "primary" : "secondary"}
                        size="sm"
                        className={`me-1 ${selectedTime === "1W" ? "btn-soft-primary" : "btn-soft-secondary"}`}
                        onClick={() => handleTimeChange("1W")}
                    >
                        1W
                    </Button>
                    <Button
                        color={selectedTime === "1M" ? "primary" : "secondary"}
                        size="sm"
                        className={`me-1 ${selectedTime === "1M" ? "btn-soft-primary" : "btn-soft-secondary"}`}
                        onClick={() => handleTimeChange("1M")}
                    >
                        1M
                    </Button>
                    <Button
                        color={selectedTime === "3M" ? "primary" : "secondary"}
                        size="sm"
                        className={`me-1 ${selectedTime === "3M" ? "btn-soft-primary" : "btn-soft-secondary"}`}
                        onClick={() => handleTimeChange("3M")}
                    >
                        3M
                    </Button>
                </div>
            </CardHeader>

            <CardBody>
                <div className="apex-charts" style={{ height: '40vh' }}>
                    <ReactApexChart
                        options={options}
                        series={series}
                        type="area"
                        height="100%"
                        className="apex-charts"
                    />
                </div>
            </CardBody>
        </Card>
    );
};

export default TotalAppUserAnalytics;
